import type { Store } from 'effector'
import type { ViewError } from './index.h'

import { combine, createEvent, createStore, sample } from 'effector'
import { or } from 'patronum'
import { features } from '~/core/flags'
import { model as i18n } from '~/core/i18n'
import { model as router } from '~/core/router'
import { model as config, remote } from '~/shared/config'

export const redirectToSignIn = createEvent<void>()

// debounced error, in order to prevent react to render component with old data
export const $viewError = createStore<ViewError>(null)

// Transformed error state into a displayable message with translation
export const $message = combine($viewError, i18n.$t, (error, { t }) => ({
  show: Boolean(error),
  title: error ? t(error) : undefined,
}))

export const $link: Store<string> = // '' by default
  config.get(remote.tria_registrationExternalDomain)

// Registration state (Sign up with Redirect / FB redirect link)
export const $isSignUpWithRedirect: Store<boolean> = $link.map((link) =>
  Boolean(link)
)

// Registration state (In-app registration / Nora flag)
export const $isInAppRegistration: Store<boolean> = features.get(
  'registrationEnabled',
  false
)

export const $enabled: Store<boolean> = or(
  $isSignUpWithRedirect,
  $isInAppRegistration
)

// indicates about enabled or disabled registration by phone
export const $signUpWithPhoneEnabled: Store<boolean> = features.get(
  'signInWithPhoneEnabled',
  false
) // `false` by default

sample({
  clock: redirectToSignIn,
  fn: () => '/sign-in',
  target: router.navigatePush,
})
